export default __webpack_public_path__ + "static/media/mypic.f6d26a52.JPG";